// Copyright 2025. WebPros International GmbH. All rights reserved.

import { ValueType } from 'react-select';
import {
    ILoadOptions,
    ISelectRequiredOption,
} from 'common/components';
import * as React from 'react';
import AsyncSelectInput from 'common/components/Select/AsyncSelectInput';
import { FILTERS } from 'admin/common/constants/tests';
import { FixedFormField } from 'admin/common/components/Filters/Styles';
import { backupNodes } from 'common/api/resources/BackupNode';
import { Translate } from '@plesk/ui-library';

export interface IBackupNodeFilterProps {
    onChange?: (option: ValueType<ISelectRequiredOption>) => void;
    value?: ValueType<ISelectRequiredOption>;
}

export const BackupNodeFilter: React.FC<IBackupNodeFilterProps> = ({
    onChange,
    value,
}) => {
    const loadBackups: ILoadOptions = async (search, loadedOptions, { page }) => {
        const response = await backupNodes.list({
            page,
            filters: {
                search,
            },
        });

        return {
            options: response.data.data.map(backupNode => ({
                label: backupNode.name,
                value: backupNode.id.toString(),
            })),
            hasMore: !!response.data.links.next,
            additional: {
                page: page + 1,
            },
        };
    };

    return (
        <FixedFormField data-cy={FILTERS.BACKUP_NODE}>
            <AsyncSelectInput
                isClearable={true}
                placeholder={<Translate content="filters.backupNode"/>}
                loadOptions={loadBackups}
                onChange={onChange}
                debounceTimeout={1000}
                additional={{ page: 1 }}
                value={value}
                menuPosition="absolute"
                menuPortalTarget={document.body}
            />
        </FixedFormField>
    );
};
